import { browserHistory } from 'react-router';
import { normalize } from 'normalizr';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';

import {
  arrayOfPriceCodes,
  arrayOfPriceLevels,
  arrayOfPriceChartItems,
  arrayOfSystemPriceCodes,
  arrayOfSystemPriceLevels,
} from '../schema';

import camelcaseKeysDeep from 'camelcase-keys-deep';

import {
  getPriceChart,
  updatePriceCharts,
  fetchSystemPriceCodes,
  fetchSystemPriceLevels,
  getPriceComponentNames,
  getOfferById,
  getPricingAuditLog,
  getLDFlagValue,
  getRevenueCenter,
} from '../../../../../api/ApiManager';
import update from 'immutability-helper';
import { sortPriceCodes, sortPriceCodesByProperty } from './helpers/sorting';
import {
  PRICE_CODE_STATUS_NEW,
  PRICE_LEVEL_STATUS_NEW,
} from '../constants/status';
import {
  setDataModifiedWarning,
  UPDATE_NOTIFICATION,
} from '../../../../../store/app';
import {
  addPriceCodesToEvent,
  removePriceCodeFromEvent,
} from '../../../modules/eventDetails';

// ------------------------------------
// constants
// ------------------------------------

export const LOAD_PRICE_CHART_BEGIN = 'LOAD_PRICE_CHART_BEGIN';
export const LOAD_PRICE_CHART_SUCCESS = 'LOAD_PRICE_CHART_SUCCESS';
export const LOAD_PRICE_CHART_FAILURE = 'LOAD_PRICE_CHART_FAILURE';

export const GET_SYSTEM_PRICE_CODES_BEGIN = 'GET_SYSTEM_PRICE_CODES_BEGIN';
export const GET_SYSTEM_PRICE_CODES_SUCCESS = 'GET_SYSTEM_PRICE_CODES_SUCCESS';
export const GET_SYSTEM_PRICE_CODES_FAILURE = 'GET_SYSTEM_PRICE_CODES_FAILURE';

export const GET_SYSTEM_PRICE_LEVELS_BEGIN = 'GET_SYSTEM_PRICE_LEVELS_BEGIN';
export const GET_SYSTEM_PRICE_LEVELS_SUCCESS =
  'GET_SYSTEM_PRICE_LEVELS_SUCCESS';
export const GET_SYSTEM_PRICE_LEVELS_FAILURE =
  'GET_SYSTEM_PRICE_LEVELS_FAILURE';

export const GET_PRICE_COMPONENT_NAMES_BEGIN =
  'GET_PRICE_COMPONENT_NAMES_BEGIN';
export const GET_PRICE_COMPONENT_NAMES_SUCCESS =
  'GET_PRICE_COMPONENT_NAMES_SUCCESS';
export const GET_PRICE_COMPONENT_NAMES_FAILURE =
  'GET_PRICE_COMPONENT_NAMES_FAILURE';

export const GET_OFFERS_BEGIN = 'GET_OFFERS_BEGIN';
export const GET_OFFERS_SUCCESS = 'GET_OFFERS_SUCCESS';
export const GET_OFFERS_FAILURE = 'GET_OFFERS_FAILURE';

export const UPDATE_PRICE_CHART_ITEM = 'UPDATE_PRICE_CHART_ITEM';
export const UPDATE_PRICE_CHART_BEGIN = 'UPDATE_PRICE_CHART_BEGIN';
export const UPDATE_PRICE_CHART_SUCCESS = 'UPDATE_PRICE_CHART_SUCCESS';
export const UPDATE_PRICE_CHART_FAILURE = 'UPDATE_PRICE_CHART_FAILURE';

export const SET_ACTIVE_PRICE_CODE = 'SET_ACTIVE_PRICE_CODE';
export const ADD_NEW_PRICE_CODES = 'ADD_NEW_PRICE_CODES';
export const ADD_NEW_PRICE_LEVELS = 'ADD_NEW_PRICE_LEVELS';
export const DELETE_PRICE_CODE = 'DELETE_PRICE_CODE';
export const DELETE_PRICE_LEVEL = 'DELETE_PRICE_LEVEL';
export const CLEAR_ADMISSIONS = 'CLEAR_ADMISSIONS';
export const SET_UNSAVED_CHANGES = 'SET_UNSAVED_CHANGES';
export const RESET_UNSAVED_CHANGES = 'RESET_UNSAVED_CHANGES';
export const CLEAR_OFFERS = 'CLEAR_OFFERS';

export const REDIRECT_TO_ADMISSIONS = 'REDIRECT_TO_ADMISSIONS';
export const REDIRECT_TO_EDP = 'REDIRECT_TO_EDP';
export const REDIRECT_TO_EDIT_PRICE_CHART_ITEM =
  'REDIRECT_TO_EDIT_PRICE_CHART_ITEM';
export const REDIRECT_TO_ZONE_SETTINGS = 'REDIRECT_TO_ZONE_SETTINGS';
export const REDIRECT_TO_FLASH_SETTINGS = 'REDIRECT_TO_FLASH_SETTINGS';
export const REDIRECT_TO_EDIT_PRICE_LEVEL = 'REDIRECT_TO_EDIT_PRICE_LEVEL';

export const REDIRECT_TO_ADD_PRICE_LEVEL = 'REDIRECT_TO_ADD_PRICE_LEVEL';
export const REDIRECT_TO_ADD_PRICE_CODE = 'REDIRECT_TO_ADD_PRICE_CODE';

export const SELECT_NEXT_PRICECODE = 'SELECT_NEXT_PRICECODE';
export const SELECT_PREV_PRICECODE = 'SELECT_PREV_PRICECODE';
export const SELECT_NEXT_PRICELEVEL = 'SELECT_NEXT_PRICELEVEL';
export const SELECT_PREV_PRICELEVEL = 'SELECT_PREV_PRICELEVEL';
export const SELECT_PRICECODE = 'SELECT_PRICECODE';
export const SELECT_PRICELEVEL = 'SELECT_PRICELEVEL';
export const SELECT_NEXT_PRICE_CHART_ITEM = 'SELECT_NEXT_PRICE_CHART_ITEM';

export const BEGIN_EDIT_DEFAULT_PRICE_LEVEL = 'BEGIN_EDIT_DEFAULT_PRICE_LEVEL';
export const SET_EDIT_PRICE_LEVEL = 'SET_EDIT_PRICE_LEVEL';
export const END_EDIT_DEFAULT_PRICE_LEVEL = 'END_EDIT_DEFAULT_PRICE_LEVEL';

export const BEGIN_EDIT_PRICE_ITEM = 'BEGIN_EDIT_PRICE_ITEM';
export const SET_EDIT_PRICE_ITEM = 'SET_EDIT_PRICE_ITEM';
export const END_EDIT_PRICE_ITEM = 'END_EDIT_PRICE_ITEM';

export const SET_EDIT_PRICE = 'SET_EDIT_PRICE';

export const SET_SELECTED_ZONE = 'SET_SELECTED_ZONE';
export const SET_SELECTED_PRICE_LEVEL = 'SET_SELECTED_PRICE_LEVEL';

export const HANDLE_PRICE_LEVEL_COMPONENTS_ENABLE =
  'HANDLE_PRICE_LEVEL_COMPONENTS_ENABLE';
export const TOGGLE_IS_SAVING = 'TOGGLE_IS_SAVING';

export const LOAD_PRICING_AUDIT_LOG_BEGIN = 'LOAD_PRICING_AUDIT_LOG_BEGIN';
export const LOAD_PRICING_AUDIT_LOG_SUCCESS = 'LOAD_PRICING_AUDIT_LOG_SUCCESS';
export const LOAD_PRICING_AUDIT_LOG_FAILURE = 'LOAD_PRICING_AUDIT_LOG_FAILURE';

export const SET_LD_FLAG = 'SET_LD_FLAG';

export const LOAD_REVENUE_CENTERS_BEGIN = 'LOAD_REVENUE_CENTERS_BEGIN';
export const LOAD_REVENUE_CENTERS_SUCCESS = 'LOAD_REVENUE_CENTERS_SUCCESS';
export const LOAD_REVENUE_CENTERS_FAILURE = 'LOAD_REVENUE_CENTERS_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

export const fetchRevenueCentersBegin = () => {
  return { type: LOAD_REVENUE_CENTERS_BEGIN };
};

export const fetchRevenueCenterSuccess = (revenueCenters) => {
  return {
    type: LOAD_REVENUE_CENTERS_SUCCESS,
    revenueCenters,
  };
};

export const fetchRevenueCenterFailure = () => {
  return { type: LOAD_REVENUE_CENTERS_FAILURE };
};

export const toggleIsSaving = (setting) => {
  return { type: TOGGLE_IS_SAVING, setting };
};

export const setSelectedZone = (zoneId) => {
  return { type: SET_SELECTED_ZONE, zoneId };
};

export const setSelectedPriceLevel = (priceLevelId) => {
  return { type: SET_SELECTED_PRICE_LEVEL, priceLevelId };
};

export const loadPriceChartStarted = (zoneId) => {
  return { type: LOAD_PRICE_CHART_BEGIN, zoneId };
};

export const loadPriceChartSuccess = (priceChart, zoneId) => {
  return { type: LOAD_PRICE_CHART_SUCCESS, priceChart, zoneId };
};

export const setLDFlag = (flag, value, isLoaded) => {
  return { type: SET_LD_FLAG, flag, value, isLoaded };
};

export const loadPriceChartFailure = () => {
  return { type: LOAD_PRICE_CHART_FAILURE };
};

export const getSystemPriceCodesBegin = () => {
  return { type: GET_SYSTEM_PRICE_CODES_BEGIN };
};

export const getSystemPriceCodesSuccess = (pCodes, admissions) => {
  return { type: GET_SYSTEM_PRICE_CODES_SUCCESS, pCodes, admissions };
};

export const getSystemPriceCodesFailure = () => {
  return { type: GET_SYSTEM_PRICE_CODES_FAILURE };
};

export const getSystemPriceLevelsBegin = () => {
  return { type: GET_SYSTEM_PRICE_LEVELS_BEGIN };
};

export const getSystemPriceLevelsSuccess = (pLevels, admissions) => {
  return { type: GET_SYSTEM_PRICE_LEVELS_SUCCESS, pLevels, admissions };
};

export const getSystemPriceLevelsFailure = () => {
  return { type: GET_SYSTEM_PRICE_LEVELS_FAILURE };
};

export const updatePriceChartBegin = () => {
  return { type: UPDATE_PRICE_CHART_BEGIN };
};

export const updatePriceChartSuccess = (eventId) => {
  return { type: UPDATE_PRICE_CHART_SUCCESS, eventId };
};

export const updatePriceChartFailure = (failureMessage) => {
  return { type: UPDATE_PRICE_CHART_FAILURE, failureMessage };
};

export const getPriceComponentNamesBegin = () => {
  return { type: GET_PRICE_COMPONENT_NAMES_BEGIN };
};

export const getPriceComponentNamesSuccess = (priceComponentNames) => {
  return { type: GET_PRICE_COMPONENT_NAMES_SUCCESS, priceComponentNames };
};

export const getPriceComponentNamesFailure = (err) => {
  return { type: GET_PRICE_COMPONENT_NAMES_FAILURE, err };
};

export const getOffersBegin = () => {
  return { type: GET_OFFERS_BEGIN };
};

export const getOffersSuccess = (data, zoneId) => {
  return { type: GET_OFFERS_SUCCESS, data, zoneId };
};

export const getOffersFailure = (err) => {
  return { type: GET_OFFERS_FAILURE, err };
};

export const selectNextPriceCode = () => {
  return { type: SELECT_NEXT_PRICECODE };
};

export const selectPrevPriceCode = () => {
  return { type: SELECT_PREV_PRICECODE };
};

export const selectNextPriceLevel = () => {
  return { type: SELECT_NEXT_PRICELEVEL };
};

export const selectPrevPriceLevel = () => {
  return { type: SELECT_PREV_PRICELEVEL };
};

export const selectPriceCode = (id) => {
  return { type: SELECT_PRICECODE, id };
};

export const selectPriceLevel = (id) => {
  return { type: SELECT_PRICELEVEL, id };
};

export const beginEditPriceItem = (pCode, pLevel) => {
  return { type: BEGIN_EDIT_PRICE_ITEM, pCode, pLevel };
};

export const endEditPriceItem = () => {
  return { type: END_EDIT_PRICE_ITEM };
};

export const setEditPriceItem = (amount) => {
  return { type: SET_EDIT_PRICE_ITEM, amount };
};

export const beginEditDefaultPriceLevel = (priceLevel) => {
  return { type: BEGIN_EDIT_DEFAULT_PRICE_LEVEL, priceLevel };
};

export const endEditDefaultPriceLevel = (
  updatedPriceChartItems,
  overrideDefaultAmount,
  updatedComponentChart,
  componentOverrides,
  enableComponents
) => {
  return {
    type: END_EDIT_DEFAULT_PRICE_LEVEL,
    updatedPriceChartItems,
    overrideDefaultAmount,
    updatedComponentChart,
    componentOverrides,
    enableComponents,
  };
};

export const setEditPriceLevel = (amount) => {
  return { type: SET_EDIT_PRICE_LEVEL, amount };
};

export const setEditPrice = (amount) => {
  return { type: SET_EDIT_PRICE, amount };
};

export const addNewPriceCodes = (eventId, zoneId, priceCodes) => {
  return (dispatch) => {
    dispatch(addPriceCodes(eventId, zoneId, priceCodes));
    dispatch(addPriceCodesToEvent(zoneId, priceCodes));
    dispatch(redirectToAdmissions(eventId, zoneId));
  };
};

export const addNewPriceLevels = (eventId, zoneId, priceLevels) => {
  return (dispatch) => {
    dispatch(addPriceLevels(eventId, zoneId, priceLevels));
    dispatch(redirectToAdmissions(eventId, zoneId));
  };
};

export const deletePriceCodes = (eventId, zoneId, priceCode) => {
  return (dispatch) => {
    dispatch(deletePriceCode(eventId, zoneId, priceCode));
    dispatch(removePriceCodeFromEvent(zoneId, priceCode));
    dispatch(redirectToAdmissions(eventId, zoneId));
  };
};

export const deletePriceLevels = (eventId, zoneId, priceLevel) => {
  return (dispatch) => {
    dispatch(deletePriceLevel(eventId, zoneId, priceLevel));
    dispatch(redirectToAdmissions(eventId, zoneId));
  };
};

export const addPriceCodes = (eventId, zoneId, priceCodes) => {
  return { type: ADD_NEW_PRICE_CODES, eventId, zoneId, priceCodes };
};

export const addPriceLevels = (eventId, zoneId, priceLevels) => {
  return { type: ADD_NEW_PRICE_LEVELS, eventId, zoneId, priceLevels };
};

export const deletePriceCode = (eventId, zoneId, priceCode) => {
  return { type: DELETE_PRICE_CODE, eventId, zoneId, priceCode };
};

export const deletePriceLevel = (eventId, zoneId, priceLevel) => {
  return { type: DELETE_PRICE_LEVEL, eventId, zoneId, priceLevel };
};

export const redirectToEditPriceChartItem = (
  eventId,
  zoneId,
  priceCodeId,
  priceLevelId
) => {
  browserHistory.push(
    `/event/${eventId}/zones/${zoneId}/pricecode/${priceCodeId}/pricelevel/${priceLevelId}`
  );
  return {
    type: REDIRECT_TO_EDIT_PRICE_CHART_ITEM,
  };
};

export const redirectToEditPriceLevel = (eventId, zoneId, priceLevelId) => {
  browserHistory.push(
    `/event/${eventId}/zones/${zoneId}/pricelevel/${priceLevelId}`
  );
  return {
    type: REDIRECT_TO_EDIT_PRICE_LEVEL,
  };
};

export const redirectToAdmissions = (eventId, zoneId) => {
  browserHistory.push(`/event/${eventId}/zones/${zoneId}`);
  return {
    type: REDIRECT_TO_ADMISSIONS,
  };
};

export const redirectToEDP = (eventId) => {
  browserHistory.push(`/events/${eventId}`);
  return {
    type: REDIRECT_TO_EDP,
  };
};

export const redirectToAddPriceCode = (eventId, zoneId) => {
  browserHistory.push(`/event/${eventId}/zones/${zoneId}/pricecodes/add`);
  return {
    type: REDIRECT_TO_ADD_PRICE_CODE,
  };
};

export const redirectToAddPriceLevel = (eventId, zoneId) => {
  browserHistory.push(`/event/${eventId}/zones/${zoneId}/pricelevels/add`);
  return {
    type: REDIRECT_TO_ADD_PRICE_LEVEL,
  };
};

export const clearAdmissions = () => {
  return {
    type: CLEAR_ADMISSIONS,
  };
};

export const togglePriceLevelComponents = () => {
  return {
    type: HANDLE_PRICE_LEVEL_COMPONENTS_ENABLE,
  };
};

export const loadPricingAuditBegin = () => {
  return { type: LOAD_PRICING_AUDIT_LOG_BEGIN };
};

export const loadPricingAuditSuccess = (data) => {
  return { type: LOAD_PRICING_AUDIT_LOG_SUCCESS, data };
};

export const loadPricingAuditFailure = (err) => {
  return { type: LOAD_PRICING_AUDIT_LOG_FAILURE, err };
};

/**
 * Load a price chart from the API for an event/zone.
 *
 * @param eventId
 * @param zoneId
 * @returns {function(*, *)}
 */
export const loadPriceChart = (eventId, zoneId) => {
  return (dispatch, getState) => {
    dispatch(loadPriceChartStarted(zoneId));
    const contextId = getState().app.contextId;
    getPriceChart(contextId, eventId, zoneId)
      .then((response) => {
        if (response.data.hasOwnProperty('PriceChart')) {
          dispatch(loadPriceChartSuccess(response.data, zoneId));
        } else {
          dispatch(updateNotifications('Price Chart failed to load.', 'error'));
          setTimeout(() => {
            dispatch({ type: 'HIDE_NOTIFICATION' });
          }, 8000);
          dispatch(loadPriceChartFailure(response.data.ResponseStatus.Message));
        }
      })
      .catch((err) => {
        dispatch(loadPriceChartFailure(err));
      });
  };
};

export const loadLDFlag = (flag) => async (dispatch, getState) => {
  try {
    const contextId = getState().app.contextId;
    const {
      data: { IsEnabled },
    } = await getLDFlagValue(contextId, flag);

    dispatch(setLDFlag(flag, IsEnabled, true));
  } catch (e) {
    dispatch(setLDFlag(flag, false, false));
  }
};

export const updatePriceChart = (data, params) => {
  return (dispatch) => {
    dispatch(updatePriceChartBegin());
    updatePriceCharts(data)
      .then((response) => {
        if (response && response.data.ResponseStatus.Message === 'Success') {
          const eventId = data.EventId;
          dispatch(
            updateNotifications('Price Chart successfully saved.', 'success')
          );
          setTimeout(() => {
            dispatch({ type: 'HIDE_NOTIFICATION' });
          }, 8000);
          dispatch(updatePriceChartSuccess(eventId));
          dispatch(resetUnsavedChanges());
          if (!params.id || !params.zoneid) {
            dispatch(redirectToEDP(eventId));
          }
        } else if (response.data.ResponseStatus.ErrorCode === '409') {
          dispatch(toggleIsSaving(false));
          dispatch(setDataModifiedWarning(true));
        } else {
          dispatch(
            updateNotifications('Price Chart failed to save.', 'error', true)
          );
          dispatch(updatePriceChartFailure('Failed to save price chart'));
        }
      })
      .catch((err) => {
        dispatch(
          updateNotifications('Price Chart failed to save.', 'error', true)
        );
        dispatch(updatePriceChartFailure(err));
      });
  };
};

/**
 * Loads available System Price Codes for a context.
 *
 * @returns {function(*, *)}
 */
export const getSystemPriceCodes = () => {
  return (dispatch, getState) => {
    dispatch(getSystemPriceCodesBegin());
    const contextId = getState().app.contextId;
    const admissions = getState().admissions;
    fetchSystemPriceCodes(contextId)
      .then((response) => {
        dispatch(
          getSystemPriceCodesSuccess(response.data.PriceCodes, admissions)
        );
      })
      .catch((err) => {
        dispatch(getSystemPriceCodesFailure(err));
      });
  };
};

/**
 * Loads available System Price Levels for a context.
 *
 * @returns {function(*, *)}
 */
export const getSystemPriceLevels = () => {
  return (dispatch, getState) => {
    dispatch(getSystemPriceLevelsBegin());
    const contextId = getState().app.contextId;
    const admissions = getState().admissions;
    fetchSystemPriceLevels(contextId)
      .then((response) => {
        dispatch(
          getSystemPriceLevelsSuccess(response.data.PriceLevels, admissions)
        );
      })
      .catch((err) => {
        dispatch(getSystemPriceLevelsFailure(err));
      });
  };
};

/**
 * Loads pricing audit log.
 *
 * @returns {function(*, *)}
 */
export const getPricingAuditLogData = (eventId, zoneId) => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    if (contextId && eventId && zoneId) {
      dispatch(loadPricingAuditBegin());
      getPricingAuditLog(contextId, eventId, zoneId)
        .then((response) => {
          dispatch(loadPricingAuditSuccess(response.data));
        })
        .catch((err) => {
          dispatch(loadPricingAuditFailure(err));
        });
    }
  };
};

export const updateNotifications = (message, status, dismissable) => {
  return {
    type: UPDATE_NOTIFICATION,
    message,
    status,
    dismissable,
  };
};

export const updatePriceChartItem = (pChartItem, zoneId) => {
  return (dispatch, getState) => {
    const admissions = getState().admissions;
    dispatch(setPriceChartItem(pChartItem, admissions, zoneId));
    browserHistory.goBack();
  };
};

export const setPriceChartItem = (pChartItem, admissions, zoneId) => {
  return {
    type: UPDATE_PRICE_CHART_ITEM,
    pChartItem,
    admissions,
    zoneId,
  };
};

export const getPriceComponents = () => {
  return (dispatch, getState) => {
    dispatch(getPriceComponentNamesBegin());
    const contextId = getState().app.contextId;
    getPriceComponentNames(contextId)
      .then((response) => {
        const comps = response.data.PriceComponents;
        const compsObj = {};
        comps.map((comp) => {
          comp.Amount = '';
          compsObj[comp.Description] = comp;
        });
        dispatch(getPriceComponentNamesSuccess(compsObj));
      })
      .catch((err) => {
        dispatch(getPriceComponentNamesFailure(err));
      });
  };
};

export const fetchRevenueCenter = () => {
  return (dispatch, getState) => {
    dispatch(fetchRevenueCentersBegin());
    const contextId = getState().app.contextId;
    getRevenueCenter(contextId)
      .then((response) => {
        const revenueCenters = response.data && response.data.RevenueCenters;
        dispatch(fetchRevenueCenterSuccess(revenueCenters));
      })
      .catch((err) => {
        dispatch(fetchRevenueCenterFailure(err));
      });
  };
};

export const getOffers = (offerId, venueId, zoneId) => {
  return (dispatch, getState) => {
    dispatch(getOffersBegin());
    const contextId = getState().app.contextId;
    getOfferById(contextId, offerId, venueId)
      .then((response) => {
        if (response.data.hasOwnProperty('Offer')) {
          dispatch(getOffersSuccess(response.data.Offer, zoneId));
        }
      })
      .catch((err) => {
        dispatch(getOffersFailure(err));
      });
  };
};

export const resetUnsavedChanges = () => {
  return {
    type: RESET_UNSAVED_CHANGES,
  };
};

export const setUnsavedChanges = () => {
  return {
    type: SET_UNSAVED_CHANGES,
  };
};

export const navigateToZoneSettings = (eventId, zoneId) => {
  browserHistory.push(`/event/${eventId}/zones/${zoneId}/settings`);
  return {
    type: REDIRECT_TO_ZONE_SETTINGS,
  };
};

export const navigateToFlashseatSettings = (eventId, zoneId) => {
  browserHistory.push(`/event/${eventId}/zones/${zoneId}/flash-settings`);
  return {
    type: REDIRECT_TO_FLASH_SETTINGS,
  };
};

export const setActivePriceCode = (pCode, pLevel, zoneId) => {
  return {
    type: SET_ACTIVE_PRICE_CODE,
    pCode,
    pLevel,
    zoneId,
  };
};

export const clearOffers = (zoneId) => {
  return { type: CLEAR_OFFERS, zoneId };
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SET_LD_FLAG]: (state, action) => {
    return {
      ...state,
      [action.flag]: { value: action.value, isLoaded: action.isLoaded },
    };
  },
  [LOAD_PRICE_CHART_BEGIN]: (state, action) => {
    return {
      ...state,
      [action.zoneId]: { isLoaded: false, offers: [] },
    };
  },
  [LOAD_PRICE_CHART_SUCCESS]: (state, action) => {
    const priceChartItems =
      camelcaseKeysDeep(
        cloneDeep(action.priceChart.PriceChart.PriceChartItems)
      ) || [];
    const priceLevels =
      camelcaseKeysDeep(cloneDeep(action.priceChart.PriceChart.PriceLevels)) ||
      [];
    priceLevels.sort(function (a, b) {
      return a.displayOrder > b.displayOrder
        ? 1
        : b.displayOrder > a.displayOrder
        ? -1
        : 0;
    });
    const priceCodes =
      camelcaseKeysDeep(cloneDeep(action.priceChart.PriceChart.PriceCodes)) ||
      [];

    priceChartItems.map((item) => {
      if (
        item.componentChart.component1Value ||
        item.componentChart.component2Value ||
        item.componentChart.component3Value ||
        item.componentChart.component4Value ||
        item.componentChart.component5Value
      ) {
        item.componentsEnabled = true;
      } else {
        item.componentsEnabled = false;
      }
      return item;
    });

    // Ensure all Price Codes and Price Levels have a Price Chart Item.
    priceCodes.forEach((pCode) => {
      priceLevels.forEach((pLevel) => {
        if (
          !find(priceChartItems, {
            priceCodeId: pCode.id,
            priceLevelId: pLevel.id,
          })
        ) {
          priceChartItems.push({
            amount: null,
            priceCodeId: Number(pCode.id),
            priceLevelId: Number(pLevel.id),
          });
        }
      });
    });

    const normalizedPriceChartItems = action.priceChart.PriceChart
      ? normalize(priceChartItems, arrayOfPriceChartItems)
      : [];
    const normalizedPriceLevels = action.priceChart.PriceChart
      ? normalize(priceLevels, arrayOfPriceLevels)
      : [];
    const normalizedPriceCodes = action.priceChart.PriceChart
      ? normalize(priceCodes, arrayOfPriceCodes)
      : [];

    if (normalizedPriceCodes.result.length > 0) {
      normalizedPriceCodes.result = sortPriceCodes(normalizedPriceCodes);
      normalizedPriceCodes.result = sortPriceCodesByProperty(
        normalizedPriceCodes,
        'pricingMode',
        'Comp'
      );
      normalizedPriceCodes.result = sortPriceCodesByProperty(
        normalizedPriceCodes,
        'status',
        'NEW',
        'ASC'
      );
    }

    // Handle cases where there are no items.
    if (!normalizedPriceChartItems.entities.priceChartItem) {
      normalizedPriceChartItems.entities.priceChartItem = {};
    }

    if (!normalizedPriceCodes.entities.priceCode) {
      normalizedPriceCodes.entities.priceCode = {};
    }

    if (!normalizedPriceLevels.entities.priceLevel) {
      normalizedPriceLevels.entities.priceLevel = {};
    }

    return {
      ...state,
      selectedPriceCode: Number(normalizedPriceCodes.result[0]),
      selectedPriceLevel: Number(normalizedPriceLevels.result[0]),
      [action.zoneId]: {
        priceChart: normalizedPriceChartItems,
        priceLevels: normalizedPriceLevels,
        priceCodes: normalizedPriceCodes,
        offers: [],
        isLoaded: true,
      },
    };
  },
  [LOAD_PRICE_CHART_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.failureMessage };
  },
  [LOAD_REVENUE_CENTERS_BEGIN]: (state) => {
    return { ...state };
  },
  [LOAD_REVENUE_CENTERS_SUCCESS]: (state, action) => {
    return {
      ...state,
      revenueCenters: action.revenueCenters,
    };
  },
  [LOAD_REVENUE_CENTERS_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.failureMessage };
  },
  [REDIRECT_TO_ADMISSIONS]: (state) => {
    return { ...state };
  },
  [REDIRECT_TO_EDP]: (state) => {
    return { ...state };
  },
  [REDIRECT_TO_ADMISSIONS]: (state) => {
    return { ...state };
  },
  [REDIRECT_TO_EDP]: (state) => {
    return { ...state };
  },
  [GET_SYSTEM_PRICE_CODES_BEGIN]: (state) => {
    return { ...state, systemPriceCodesLoaded: false };
  },
  [GET_SYSTEM_PRICE_LEVELS_BEGIN]: (state) => {
    return { ...state, systemPriceLevelsLoaded: false };
  },
  [GET_SYSTEM_PRICE_CODES_SUCCESS]: (state, action) => {
    const systemPriceCodes = camelcaseKeysDeep(action.pCodes);
    return {
      ...state,
      systemPriceCodes: normalize(systemPriceCodes, arrayOfSystemPriceCodes),
      systemPriceCodesLoaded: true,
    };
  },
  [GET_SYSTEM_PRICE_LEVELS_SUCCESS]: (state, action) => {
    const systemPriceLevels = camelcaseKeysDeep(action.pLevels);
    return {
      ...state,
      systemPriceLevels: normalize(systemPriceLevels, arrayOfSystemPriceLevels),
      systemPriceLevelsLoaded: true,
    };
  },
  [GET_SYSTEM_PRICE_CODES_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.failureMessage };
  },
  [GET_SYSTEM_PRICE_LEVELS_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.failureMessage };
  },
  [LOAD_PRICING_AUDIT_LOG_BEGIN]: (state) => {
    return { ...state };
  },
  [LOAD_PRICING_AUDIT_LOG_SUCCESS]: (state, action) => {
    const activity = camelcaseKeysDeep(action.data.Items);
    return {
      ...state,
      pricingAuditLog: activity,
    };
  },
  [LOAD_PRICING_AUDIT_LOG_FAILURE]: (state, action) => {
    return { ...state, errorMessage: action.err };
  },
  [UPDATE_PRICE_CHART_ITEM]: (state, action) => {
    const zone = cloneDeep(state[action.zoneId]);
    const priceCodeId = Number(action.pChartItem.priceCodeId);
    const priceLevelId = Number(action.pChartItem.priceLevelId);
    zone.priceChart.entities.priceChartItem[`${priceLevelId}-${priceCodeId}`] =
      action.pChartItem;
    return {
      ...state,
      [action.zoneId]: zone,
      selectedPriceLevel: Number(priceLevelId),
      selectedPriceCode: Number(priceCodeId),
      unsavedChanges: true,
    };
  },
  [UPDATE_PRICE_CHART_BEGIN]: (state) => {
    return { ...state, isSavingPriceChart: true };
  },
  [UPDATE_PRICE_CHART_SUCCESS]: (state, action) => {
    return { ...state, newEventId: action.eventId, isSavingPriceChart: false };
  },
  [UPDATE_PRICE_CHART_FAILURE]: (state, action) => {
    return {
      ...state,
      error: action.failureMessage,
      isSavingPriceChart: false,
    };
  },
  [GET_PRICE_COMPONENT_NAMES_BEGIN]: (state) => {
    return { ...state };
  },
  [GET_PRICE_COMPONENT_NAMES_SUCCESS]: (state, action) => {
    return {
      ...state,
      priceComponentNames: action.priceComponentNames,
      componentsLoaded: true,
    };
  },
  [GET_PRICE_COMPONENT_NAMES_FAILURE]: (state) => {
    return { ...state };
  },
  [ADD_NEW_PRICE_CODES]: (state, action) => {
    const zone = cloneDeep(state[action.zoneId]);
    const priceCodes = zone.priceCodes;
    const priceLevels = zone.priceLevels;
    const priceChart = zone.priceChart;

    if (!priceCodes.entities.priceCode) {
      priceCodes.entities.priceCode = {};
    }

    action.priceCodes.map((priceCode) => {
      if (!priceLevels.result.length) {
        if (priceCode.pricingMode !== 'Comp') {
          priceCode.status = PRICE_CODE_STATUS_NEW;
        }
        priceCodes.entities.priceCode[priceCode.id] = priceCode;
        priceCodes.result.push(Number(priceCode.id));
      }
      priceLevels.result.forEach((priceLevel) => {
        const defaultAmount =
          zone.priceLevels.entities.priceLevel[priceLevel].defaultAmount;
        const defaultComponents =
          zone.priceLevels.entities.priceLevel[priceLevel].components;
        const componentsEnabled =
          zone.priceLevels.entities.priceLevel[priceLevel].componentsEnabled;
        const priceLevelEntity = cloneDeep(
          zone.priceLevels.entities.priceLevel[priceLevel]
        );
        const components = priceLevelEntity.components;
        const componentNames = components && Object.keys(components);

        const componentChart = components
          ? {
              component1Price: components[componentNames[0]].Amount,
              component2Price: components[componentNames[1]].Amount,
              component3Price: components[componentNames[2]].Amount,
              component4Price: components[componentNames[3]].Amount,
              component5Price: components[componentNames[4]].Amount,
            }
          : {};

        if (priceCode.pricingMode !== 'Comp') {
          priceCode.status = PRICE_CODE_STATUS_NEW;
        }
        priceCodes.entities.priceCode[priceCode.id] = priceCode;
        priceCodes.result.push(Number(priceCode.id));
        priceChart.entities.priceChartItem[`${priceLevel}-${priceCode.id}`] = {
          priceCodeId: Number(priceCode.id),
          priceLevelId: Number(priceLevel),
          amount: defaultAmount ? defaultAmount : null,
          componentChart: defaultComponents
            ? defaultComponents
            : componentChart,
          componentsEnabled: componentsEnabled && componentsEnabled,
        };
        priceChart.result.push(`${priceLevel}-${priceCode.id}`);
      });
    });

    priceCodes.result = sortPriceCodes(priceCodes);
    priceCodes.result = sortPriceCodesByProperty(
      priceCodes,
      'pricingMode',
      'Comp'
    );
    priceCodes.result = sortPriceCodesByProperty(
      priceCodes,
      'status',
      'NEW',
      'ASC'
    );

    zone.priceChart = priceChart;
    zone.priceCodes = priceCodes;

    return {
      ...state,
      [action.zoneId]: zone,
      unsavedChanges: true,
    };
  },
  [ADD_NEW_PRICE_LEVELS]: (state, action) => {
    const zone = cloneDeep(state[action.zoneId]);
    const priceCodes = zone.priceCodes;
    const priceLevels = zone.priceLevels;
    const priceChart = zone.priceChart;

    action.priceLevels.map((priceLevel) => {
      priceLevels.entities.priceLevel[priceLevel.id] = priceLevel;
      priceLevels.result.push(Number(priceLevel.id));

      priceCodes.result.forEach((priceCode) => {
        const defaultComponents = {
          component1Price: 0,
          component2Price: 0,
          component3Price: 0,
          component4Price: 0,
          component5Price: 0,
        };

        priceLevel.status = PRICE_LEVEL_STATUS_NEW;

        priceChart.entities.priceChartItem[`${priceLevel.id}-${priceCode}`] = {
          priceCodeId: Number(priceCode),
          priceLevelId: Number(priceLevel.id),
          amount: null,
          componentChart: defaultComponents,
          componentsEnabled: false,
        };
        priceChart.result.push(`${priceLevel.id}-${priceCode}`);
      });
    });

    zone.priceChart = priceChart;
    zone.priceLevels = priceLevels;

    return {
      ...state,
      [action.zoneId]: zone,
      unsavedChanges: true,
    };
  },
  [DELETE_PRICE_CODE]: (state, action) => {
    const zone = cloneDeep(state[action.zoneId]);
    const priceCodes = zone.priceCodes;
    const priceLevels = zone.priceLevels;
    const priceChart = zone.priceChart;
    delete priceCodes.entities.priceCode[action.priceCode];
    priceCodes.result = priceCodes.result.filter(
      (item) => Number(action.priceCode) !== Number(item)
    );
    priceLevels.result.forEach((priceLevel) => {
      delete priceChart.entities.priceChartItem[
        `${priceLevel}-${action.priceCode}`
      ];
      priceChart.result = priceChart.result.filter(
        (item) => `${priceLevel}-${Number(action.priceCode)}` !== item
      );
    });
    return {
      ...state,
      [action.zoneId]: zone,
      unsavedChanges: true,
    };
  },
  [DELETE_PRICE_LEVEL]: (state, action) => {
    const zone = cloneDeep(state[action.zoneId]);
    const priceCodes = zone.priceCodes;
    const priceLevels = zone.priceLevels;
    const priceChart = zone.priceChart;
    delete priceLevels.entities.priceLevel[action.priceLevel];
    priceLevels.result = priceLevels.result.filter(
      (item) => Number(action.priceLevel) !== Number(item)
    );
    priceCodes.result.forEach((priceCode) => {
      delete priceChart.entities.priceChartItem[
        `${action.priceLevel}-${priceCode}`
      ];
      priceChart.result = priceChart.result.filter(
        (item) => `${action.priceLevel}-${Number(priceCode)}` !== item
      );
    });
    return {
      ...state,
      [action.zoneId]: zone,
      unsavedChanges: true,
    };
  },
  [DELETE_PRICE_LEVEL]: (state, action) => {
    const zone = cloneDeep(state[action.zoneId]);
    const priceCodes = zone.priceCodes;
    const priceLevels = zone.priceLevels;
    const priceChart = zone.priceChart;
    delete priceLevels.entities.priceLevel[action.priceLevel];
    priceLevels.result = priceLevels.result.filter(
      (item) => Number(action.priceLevel) !== Number(item)
    );
    priceCodes.result.forEach((priceCode) => {
      delete priceChart.entities.priceChartItem[
        `${action.priceLevel}-${priceCode}`
      ];
      priceChart.result = priceChart.result.filter(
        (item) => `${action.priceLevel}-${Number(priceCode)}` !== item
      );
    });
    return {
      ...state,
      [action.zoneId]: zone,
      unsavedChanges: true,
    };
  },
  [CLEAR_ADMISSIONS]: (state) => {
    return { ...state, ...initialState };
  },
  [SET_UNSAVED_CHANGES]: (state) => {
    return { ...state, unsavedChanges: true };
  },
  [RESET_UNSAVED_CHANGES]: (state) => {
    return { ...state, unsavedChanges: false };
  },
  [GET_OFFERS_BEGIN]: (state) => {
    return { ...state };
  },
  [GET_OFFERS_SUCCESS]: (state, action) => {
    const offer = camelcaseKeysDeep(action.data) || [];
    return update(state, { [action.zoneId]: { offers: { $push: [offer] } } });
  },
  [GET_OFFERS_FAILURE]: (state) => {
    return { ...state };
  },
  [REDIRECT_TO_ZONE_SETTINGS]: (state) => {
    return { ...state };
  },
  [REDIRECT_TO_FLASH_SETTINGS]: (state) => {
    return { ...state };
  },
  [REDIRECT_TO_EDIT_PRICE_LEVEL]: (state) => {
    return { ...state };
  },
  [REDIRECT_TO_EDIT_PRICE_LEVEL]: (state) => {
    return { ...state };
  },
  [SET_ACTIVE_PRICE_CODE]: (state, action) => {
    const zone = { ...state[action.zoneId] };
    const priceChart = zone.priceChart;
    const index = findIndex(priceChart, {
      PriceCodeId: Number(action.pCode),
      PriceLevelId: Number(action.pLevel),
    });
    priceChart[index].active = true;

    return update(state, {
      [action.zoneId]: { priceChart: { $set: priceChart } },
      unsavedChanges: { $set: true },
    });
  },
  [SELECT_NEXT_PRICECODE]: (state) => {
    const priceCodes = state[state.selectedZone].priceCodes.result;
    const pCodeIndex = priceCodes.indexOf(state.selectedPriceCode.toString());
    return {
      ...state,
      selectedPriceCode:
        pCodeIndex === priceCodes.length - 1
          ? Number(priceCodes[0])
          : Number(priceCodes[pCodeIndex + 1]),
    };
  },
  [SELECT_PREV_PRICECODE]: (state) => {
    const priceCodes = state[state.selectedZone].priceCodes.result;
    const pCodeIndex = priceCodes.indexOf(state.selectedPriceCode.toString());
    return {
      ...state,
      selectedPriceCode:
        pCodeIndex === 0
          ? Number(priceCodes[priceCodes.length - 1])
          : Number(priceCodes[pCodeIndex - 1]),
    };
  },
  [SELECT_PRICECODE]: (state, action) => {
    return {
      ...state,
      selectedPriceCode: action.id,
    };
  },
  [SELECT_PRICELEVEL]: (state, action) => {
    return {
      ...state,
      selectedPriceLevel: action.id,
    };
  },
  [SELECT_NEXT_PRICELEVEL]: (state) => {
    const priceLevels = state[state.selectedZone].priceLevels.result;
    const pLevelIndex = priceLevels.indexOf(Number(state.selectedPriceLevel));
    return {
      ...state,
      selectedPriceLevel:
        pLevelIndex === priceLevels.length - 1
          ? priceLevels[0]
          : priceLevels[pLevelIndex + 1],
    };
  },
  [SELECT_PREV_PRICELEVEL]: (state) => {
    const priceLevels = state[state.selectedZone].priceLevels.result;
    const pLevelIndex = priceLevels.indexOf(Number(state.selectedPriceLevel));
    return {
      ...state,
      selectedPriceLevel:
        pLevelIndex === 0
          ? priceLevels[priceLevels.length - 1]
          : priceLevels[pLevelIndex - 1],
    };
  },
  [SELECT_NEXT_PRICE_CHART_ITEM]: (state) => {
    const newState = { ...state };
    const entities =
      newState[state.selectedZone].priceChart.entities.priceChartItem;
    const keys = Object.keys(entities);
    const selected = keys[Number(newState.selectedIndex) + 1];
    return {
      ...state,
      selectedIndex: Number(newState.selectedIndex) + 1,
      selectedPriceCode: entities[selected].priceCodeId,
      selectedPriceLevel: entities[selected].priceLevelId,
    };
  },
  [BEGIN_EDIT_PRICE_ITEM]: (state, action) => {
    const zone = cloneDeep(state[state.selectedZone]);
    const key = `${action.pLevel}-${action.pCode}`;
    const amount =
      zone.priceChart.entities.priceChartItem[key].amount !== 'NaN'
        ? zone.priceChart.entities.priceChartItem[key].amount
        : '';
    const pricingMode =
      zone.priceCodes.entities.priceCode[Number(action.pCode)].pricingMode;
    return {
      ...state,
      selectedPriceCode: Number(action.pCode),
      selectedPriceLevel: action.pLevel,
      priceChartItemEdit: pricingMode !== 'Comp',
      priceChartLevelEdit: false,
      editPrice: amount,
    };
  },
  [END_EDIT_PRICE_ITEM]: (state) => {
    return { ...state, priceChartItemEdit: false };
  },
  [BEGIN_EDIT_DEFAULT_PRICE_LEVEL]: (state, action) => {
    const zone = cloneDeep(state[state.selectedZone]);
    const priceLevels = zone.priceLevels;
    const hasDefault = priceLevels.entities.priceLevel[action.priceLevel]
      ? priceLevels.entities.priceLevel[action.priceLevel].defaultAmount
      : false;
    let components;

    if (!hasDefault) {
      components = priceLevels.entities.priceLevel[
        action.priceLevel
      ].components = {
        component1Price: 0,
        component2Price: 0,
        component3Price: 0,
        component4Price: 0,
        component5Price: 0,
      };
    } else {
      components =
        priceLevels.entities.priceLevel[action.priceLevel].components;
    }

    zone.priceLevels = priceLevels;

    return {
      ...state,
      [state.selectedZone]: zone,
      editPriceComponents: components,
      editPrice: components ? components.defaultAmount : null,
      priceChartLevelEdit: true,
      priceChartItemEdit: false,
      selectedPriceLevel: Number(action.priceLevel),
    };
  },
  [END_EDIT_DEFAULT_PRICE_LEVEL]: (state, action) => {
    const zone = cloneDeep(state[state.selectedZone]);
    const zoneClone = cloneDeep(state[state.selectedZone]);
    const priceLevels = zone.priceLevels;
    const updatedPriceChartItems = action.updatedPriceChartItems; //
    const updatedComponents = action.updatedComponentChart; // Object with component names set to value for override.
    const componentOverrides = action.componentOverrides; // Object w/ component names set to true for an override.
    const overrideDefaultAmount = action.overrideDefaultAmount; // Boolean of default amount override checked.
    const enableComponents = action.enableComponents;

    // Set the Price Level Defaults to existing Price Level entity.
    priceLevels.entities.priceLevel[state.selectedPriceLevel].defaultAmount =
      state.editPrice;
    priceLevels.entities.priceLevel[
      state.selectedPriceLevel
    ].overrideDefaultAmount = overrideDefaultAmount;
    priceLevels.entities.priceLevel[
      state.selectedPriceLevel
    ].components = updatedComponents;
    priceLevels.entities.priceLevel[
      state.selectedPriceLevel
    ].componentsEnabled = enableComponents;
    priceLevels.entities.priceLevel[
      state.selectedPriceLevel
    ].componentOverrides = componentOverrides;
    zone.priceLevels = priceLevels;

    // Update Price Chart Items when the override checkbox was selected.
    zone.priceChart.result.forEach((item) => {
      const pLevel = Number(item.split('-')[0]);
      const pCode = Number(item.split('-')[1]);
      const isComp =
        zone.priceCodes.entities.priceCode[pCode] &&
        zone.priceCodes.entities.priceCode[pCode].pricingMode === 'Comp';

      const priceChartItems = find(updatedPriceChartItems, {
        priceCodeId: pCode,
        priceLevelId: pLevel,
      });

      const existingPriceChartItem = find(
        zoneClone.priceChart.entities.priceChartItem,
        {
          priceCodeId: pCode,
          priceLevelId: pLevel,
        }
      );
      if (priceChartItems && !isComp) {
        // Set the Price Chart Item to the Default Price Level

        const updatedComponentChart = Object.assign(
          {},
          existingPriceChartItem.componentChart,
          priceChartItems.componentChart
        );
        zone.priceChart.entities.priceChartItem[item] = priceChartItems;

        // Set an existing component price to 0 unless there already is a valid price.
        const existingComponent1Price =
          (zone.priceChart.entities.priceChartItem[item].componentChart &&
            zone.priceChart.entities.priceChartItem[item].componentChart[
              'component1Price'
            ]) ||
          0;

        const existingComponent2Price =
          (zone.priceChart.entities.priceChartItem[item].componentChart &&
            zone.priceChart.entities.priceChartItem[item].componentChart[
              'component2Price'
            ]) ||
          0;

        const existingComponent3Price =
          (zone.priceChart.entities.priceChartItem[item].componentChart &&
            zone.priceChart.entities.priceChartItem[item].componentChart[
              'component3Price'
            ]) ||
          0;
        const existingComponent4Price =
          (zone.priceChart.entities.priceChartItem[item].componentChart &&
            zone.priceChart.entities.priceChartItem[item].componentChart[
              'component4Price'
            ]) ||
          0;
        const existingComponent5Price =
          (zone.priceChart.entities.priceChartItem[item].componentChart &&
            zone.priceChart.entities.priceChartItem[item].componentChart[
              'component5Price'
            ]) ||
          0;

        // Set the component prices to either an override price or the existing component price.
        const chart = {
          ...updatedComponentChart,
          component1Price: componentOverrides['component1Price']
            ? updatedComponents['component1Price']
            : existingComponent1Price,
          component2Price: componentOverrides['component2Price']
            ? updatedComponents['component2Price']
            : existingComponent2Price,
          component3Price: componentOverrides['component3Price']
            ? updatedComponents['component3Price']
            : existingComponent3Price,
          component4Price: componentOverrides['component4Price']
            ? updatedComponents['component4Price']
            : existingComponent4Price,
          component5Price: componentOverrides['component5Price']
            ? updatedComponents['component5Price']
            : existingComponent5Price,
          // since only fixed values can be overridden, need to update value and price
          component1Value: componentOverrides['component1Price']
            ? updatedComponents['component1Price']
            : updatedComponentChart.component1Value,
          component2Value: componentOverrides['component2Price']
            ? updatedComponents['component2Price']
            : updatedComponentChart.component2Value,
          component3Value: componentOverrides['component3Price']
            ? updatedComponents['component3Price']
            : updatedComponentChart.component3Value,
          component4Value: componentOverrides['component4Price']
            ? updatedComponents['component4Price']
            : updatedComponentChart.component4Value,
          component5Value: componentOverrides['component5Price']
            ? updatedComponents['component5Price']
            : updatedComponentChart.component5Value,
        };

        const sum =
          Number(chart.component1Price) +
          Number(chart.component2Price) +
          Number(chart.component3Price) +
          Number(chart.component4Price) +
          Number(chart.component5Price);

        const ticketRevenue =
          zone.priceChart.entities.priceChartItem[item].amount;
        if (sum <= ticketRevenue) {
          zone.priceChart.entities.priceChartItem[item].componentChart = chart;
          zone.priceChart.entities.priceChartItem[item].componentsEnabled =
            enableComponents && Object.keys(componentOverrides).length > 0;
        }
        componentOverrides.length > 0 &&
          componentOverrides.forEach((component) => {
            if (sum < ticketRevenue) {
              zone.priceChart.entities.priceChartItem[item].componentChart[
                component
              ] = updatedComponents[component];
            }
          });
      } else {
        zone.priceChart.entities.priceChartItem[item] =
          zone.priceChart.entities.priceChartItem[`${pLevel}-${pCode}`];
      }
    });

    return {
      ...state,
      priceChartLevelEdit: false,
      [state.selectedZone]: zone,
      unsavedChanges: true,
      editPriceComponents: {},
      editPrice: '',
    };
  },
  [SET_EDIT_PRICE_ITEM]: (state) => {
    const zone = cloneDeep(state[state.selectedZone]);
    const key = `${state.selectedPriceLevel}-${state.selectedPriceCode}`;
    zone.priceChart.entities.priceChartItem[key].amount = state.editPrice;
    if (state.editPrice === '') {
      zone.priceChart.entities.priceChartItem[key].componentChart = {};
      zone.priceChart.entities.priceChartItem[key].componentsEnabled = false;
    }
    return {
      ...state,
      [state.selectedZone]: zone,
      unsavedChanges: true,
      editPrice: 0,
    };
  },
  [SET_EDIT_PRICE]: (state, action) => {
    return { ...state, editPrice: action.amount };
  },
  [SET_EDIT_PRICE_LEVEL]: (state) => {
    const zone = cloneDeep(state[state.selectedZone]);
    const pItems = filter(zone.priceChart.entities.priceChartItem, {
      priceLevelId: Number(state.selectedPriceLevel),
    });
    pItems.map((item) => {
      const key = `${item.priceLevelId}-${item.priceCodeId}`;
      const pricingMode =
        zone.priceCodes.entities.priceCode[Number(item.priceCodeId)]
          .pricingMode;
      zone.priceChart.entities.priceChartItem[key].amount =
        pricingMode !== 'Comp' ? state.editPrice : 0;
    });
    return {
      ...state,
      [state.selectedZone]: zone,
      unsavedChanges: true,
      editPrice: 0,
    };
  },
  [SET_SELECTED_ZONE]: (state, action) => {
    return { ...state, selectedZone: action.zoneId };
  },
  [SET_SELECTED_PRICE_LEVEL]: (state, action) => {
    return { ...state, selectedPriceLevel: action.priceLevelId };
  },
  [HANDLE_PRICE_LEVEL_COMPONENTS_ENABLE]: (state) => {
    const zone = cloneDeep(state[state.selectedZone]);
    const priceLevel =
      zone.priceLevels.entities.priceLevel[state.selectedPriceLevel];
    priceLevel['componentsEnabled'] = !priceLevel['componentsEnabled']
      ? 'true'
      : false;
    zone.priceLevels.entities.priceLevel[state.selectedPriceLevel] = priceLevel;
    return { ...state, [state.selectedZone]: zone };
  },
  [TOGGLE_IS_SAVING]: (state, { setting }) => {
    return {
      ...state,
      isSavingPriceChart: setting,
    };
  },
  [CLEAR_OFFERS]: (state, { zoneId }) => {
    if (!state[zoneId]) return state;
    const zone = { ...state[zoneId] };
    zone.offers = [];
    return {
      ...state,
      [zoneId]: zone,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  componentsLoaded: false,
  unsavedChanges: false,
  systemPriceCodes: [],
  systemPriceLevels: [],
  systemPriceCodesLoaded: false,
  systemPriceLevelsLoaded: false,
  priceComponentNames: {},
  selectedPriceCode: 0,
  selectedPriceLevel: 0,
  selectedZone: '',
  editPrice: 0,
  editPriceComponents: {
    enabled: false,
  },
  priceChartItemEdit: false,
  priceChartLevelEdit: false,
  isSavingPriceChart: false,
  selectedIndex: 0,
  modified: '',
  pricingAuditLog: [],
  revenueCenters: [],
};
export default function admissionsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/EventDetails/routes/admissions/modules/admissions.js